import React from "react";
import "./Profile.scss";
import {MDBBox, MDBModal, MDBModalBody} from "mdbreact";
import BottomNav from "../../component/BottomNav/BottomNav";
import {withRouter} from "react-router-dom";
import {Fade, Zoom, Flip} from 'react-reveal'
import confetti from "canvas-confetti";
import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import UserLeaderboardQuery from "../../queries/UserLeaderboardQuery";
import {AddProfileData, setActivePage, setLoginStep} from "../../Actions";
import {connect} from "react-redux";
import {compose} from "redux";
import Loading from "../../component/Loading";
import FlipAnimation from "../../component/FlipAnimation";
import AddMoney from "../UserWallet/AddMoney";
import WithdrawMoney from "../UserWallet/WithdrawMoney";
import CashDetail from "../UserWallet/CashDetail";
import ReactTooltip from "react-tooltip";
import {isNanHandler} from "../../util";
import {assetUrl} from "../../serviceApi";
import Login from "../Login/Login";

const crown = assetUrl+'images/leaderboard_crown.svg'
const arrow_left = assetUrl+"images/arrow-left-white.svg"
const wallet = assetUrl+"images/wallet_white.svg"
const bell = assetUrl+"images/clarity_bell_white.svg"
const bellEmpty = assetUrl+'images/Notifications-bell-empty-white.svg'
const leader = assetUrl+"images/leaderboard_tag_icon.svg"
const indicator = assetUrl+"images/info_updated_leaderboard.svg"
const number = assetUrl+"tmp-images/number.svg"
const arrow_up = assetUrl+"tmp-images/arrow_up.svg"
const one = assetUrl+"images/one1.png"
const steps = assetUrl+'images/leaderboard_topper_step.svg'
const growthArrow = assetUrl+'images/icon_profit_arrow.svg'
const lossArrow = assetUrl+'images/icon_loss_arrow.svg'
const newuserIllustration = assetUrl+'images/newuser-leaderboard1.png'
const profileConfetti = assetUrl+'images/Confetti_Leaderboard.svg'
const animationCup_bg = assetUrl+'images/leaderboard_updated_cup_confetti.svg'
const animationCup = assetUrl+'images/cup_leaderboard_your.png'
const arrow_down = assetUrl+"tmp-images/arrow_down.svg"
const three = assetUrl+"images/three.svg"


class Profile extends React.Component {
	state = {
		active: "today",
		confettiFired: false,
		top_users: [],
		loading: false,
		leader_board_data: [],
		current_user: {},
		colorList: [],
		notification: [],
		yourCardConfetti: false,
		// walletData: false,
		currentModal: "",
		login_modal:false
	}

	componentDidMount() {
		this.props.setActivePage("chart");
		this.getLeaderboardData();
	}

	setActiveModal = (args) => {
		this.setState({
			currentModal: args,
		})
	}

	getLeaderboardData = () => {
		let variables = {}

		let tempColorList = []
		if (this.state.active === "week") {
			variables['weekly'] = true;
		}
		const colorCodeGenerator = () => {
			let letters = "0123456789ABCDEF"
			let color = '#';
			for (let i = 0; i < 6; i++) {
				color += letters[(Math.floor(Math.random() * 16))];

			}
			return color
		}
		this.updateLoading(true);
		fetchQuery(environment, UserLeaderboardQuery, variables)
			.toPromise()
			.then(response => {

				if (response.userLeaderboard !== null && response.userLeaderboard.length > 0) {

					let top_users = response.userLeaderboard.slice(0, 3);
					let temp_currentUser_id

					for (let i = 0; i < response.userLeaderboard.length; i++) {
						let tempColor = colorCodeGenerator()
						if (response.userLeaderboard[i].user_id === this.props.user_details.user.id) {
							temp_currentUser_id = (response.userLeaderboard[i].index)
						}
						tempColorList.push(tempColor)

					}

					if (tempColorList.length === response.userLeaderboard.length) {

						this.setState({
							leader_board_data: response.userLeaderboard.slice(3),
							top_users: top_users,
							current_user: temp_currentUser_id !== undefined   ? response.userLeaderboard[temp_currentUser_id] : {},
							colorList: tempColorList
						})
						this.updateLoading(false);
						setTimeout(() => {
							if (!this.state.confettiFired) {
								// confetti();
								this.setState({
									confettiFired: true
								})

							}
						}, 1200)
					}

				} else {
					this.setState({
						leader_board_data: [
							// 	{
							// 	id:0,
							// 	userName:"Lorem",
							// 	growth:40,
							// 	place:"Lorem",
							//
							// },{
							// 	id:1,
							// 	userName:"ipsum",
							// 	growth:40,
							// 	place:"ipsum",
							//
							// },
						],
						top_users: [],
						current_user: {}
					})
					this.updateLoading(false);
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					leader_board_data: [],
					top_users: [],
					current_user: {}
				})
			});
	}

	HandleListClick = (item) => {
		this.setState({
			active: item
		})
		this.props.history.push("/profile-detail");
	}

	updateLoading = (action) => {

		this.setState({
			loading: action
		})
	}

	toggleTabActive = (value) => {
		this.setState({
			active: value
		}, () => {
			this.getLeaderboardData();
		})
	}

	selectProfile = (data) => {
		this.props.setUserProfileData(data);
		this.props.history.push('/profile-detail');
	}
	checkUserLoggedIn = (action) => {
		if(this.props.logged_in === false){
			this.openLoginModal();
		} else if(action === "wallet") {
			this.setState({currentModal: "cash"})
		} else if(action === "notification") {
			this.props.history.push("/notification")
		}
	}
	openLoginModal = () => {
		this.setState({
			login_modal:true
		});
	}
	closeLoginModal = () => {
		this.setState({
			login_modal:false
		});
	}
	completeLogin = () => {
		this.closeLoginModal();
		window.location.reload();
		// this.getWalletData();
	}

	render() {

		const {active, top_users, current_user, leader_board_data} = this.state;

		if (this.state.confettiFired && !this.state.yourCardConfetti) {
			setTimeout(() => {
				this.setState({yourCardConfetti: true})
			}, 3500)

		}
		const truncate = (str) => {
			return str.length > 10 ? str.substring(0, 9) + "..." : str;
		}



		return (
			<Loading loading={this.state.loading}>
				<>
					<MDBBox className="profile-component">
						{/*nav*/}
						<div className="header">
							<div className="d-flex justify-content-between align-items-center">
								<div className="nav_top  d-flex align-items-center">
									<img alt={"alt"} src={arrow_left} className="nav_arrow"
										 onClick={() => this.props.history.goBack()}/>
									<p className="nav_detail my-0 px-2">NETA</p>
								</div>
								<div className="navbar_Top d-flex ">
									<img alt={"alt"} src={wallet} className="nav_wallet px-4 "
										// onClick={() => this.setState({currentModal: "cash"})}
										 onClick={()=>this.checkUserLoggedIn("wallet")}
									/>
									<img alt={"alt"} src={this.state.notification.length > 0 ? bell : bellEmpty}
										 className="nav_group"
										 onClick={()=>this.checkUserLoggedIn("notification")}
										// onClick={() => this.props.history.push("/notification")}
									/>
								</div>
							</div>

						</div>

						{/* title section */}
						<div className=" leaderboard_title d-flex justify-content-between py-3 px-4">
							<div className="d-flex align-items-center">
								<img alt={"alt"} src={leader} className="leader_image my-1"/>
								<p className="leader_title my-1 px-2">Leaderboard</p>
								<img alt={"alt"} src={indicator} className="indicator_image my-1" data-tip
									 data-for={'leaderboard'}/>
								<ReactTooltip id='leaderboard' type='light' effect={"solid"} place={"bottom"}
											  style={{background: "rgba(255, 255, 255, 0.28)"}}>
									<span className={"tooltip-analyst"}>See where you stand in the country<br/>   for your political knowledge.Ranking<br/>  is based  on growth of the portfolio.</span>
								</ReactTooltip>
							</div>
							{/*<select className={"leaderboard-select p-1 my-2"}>*/}
							{/*	<option>All India</option>*/}
							{/*	<option>State</option>*/}
							{/*	<option>District</option>*/}

							{/*</select>*/}
						</div>

						<div style={{marginTop: "28px"}} className={"container topper-section my-4"}>

							{/* topper images   */}
							<div className="image_gallery d-flex pt-3">

								<div className="text_wrapping text-center"
									 onClick={() => this.selectProfile(top_users[1])}>
									<Zoom delay={1000}>
										<div className="image_number " style={{marginTop: "80px"}}>
											{/*<div className="d-flex justify-content-center">*/}
											{/*	<p className="number_wrap px-1 my-1">{top_users[1] ? top_users[1].growth : 0}</p>*/}
											{/*	/!*<img alt={"alt"} src={arrow_up} className="arrow_up_green"/>*!/*/}
											{/*</div>*/}
											<div className={"topper-avatar-wrap-left"}>
												{
													top_users[1] && top_users[1].avatar_url ?
														<img src={top_users[1].avatar_url} alt={"alt"}
															 className={"topper-avatar-pic"}/>
														:
														<p className={"topper-avatar-side mb-0"}>{top_users[1] && (top_users[1].short_username).toUpperCase()}</p>
												}

											</div>
											{/*<img alt={"alt"} src={ProfilePic} className="sheena_image "/>*/}
											<img alt={"alt"} src={number} className="number_image"/>
										</div>
										<p className="text_wrap my-1 pt-4">
											{top_users[1] ? truncate(top_users[1].user_first) : ""}

										</p>
									</Zoom>
								</div>

								<div className="text_wrapping text-center"
									 onClick={() => this.selectProfile(top_users[0])}>
									<Zoom delay={800}>
										<div className="image_number">
											<div className={"crown-img"}><Zoom delay={700}><img src={crown}
																								alt="alt"/></Zoom></div>
											{/*<div className="d-flex justify-content-center">*/}
											{/*	<p className="number_wrap px-1 my-1">{top_users[0] ? top_users[0].growth : 0}</p>*/}
											{/*	/!*<img alt={"alt"} src={arrow_up} className="arrow_up_green"/>*!/*/}
											{/*</div>*/}
											<div className={"topper-avatar-wrap-center"}>
												{
													top_users[0] && top_users[0].avatar_url ?
														<img src={top_users[0].avatar_url} alt={'alt'}
															 className={"topper-avatar-pic"}/>
														:
														<p className={"topper-avatar-center mb-0"}>{top_users[0] && (top_users[0].short_username).toUpperCase()}</p>
												}

											</div>
											{/*<img alt={"alt"} src={ProfilePic} className="harish_image"/>*/}
											<img alt={"alt"} src={one} className="number_image_one"/>
										</div>
										<p className="text_wrap my-1 pt-4">
											{top_users[0] ? truncate(top_users[0].user_first) : ""}

										</p>
									</Zoom>
								</div>

								<div className="text_wrapping text-center"
									 onClick={() => this.selectProfile(top_users[2])}>
									<Zoom delay={1400}>
										<div className="image_number " style={{marginTop: "80px"}}>
											{/*<div className="d-flex  justify-content-center">*/}
											{/*	<p className="number_wrap px-1 my-1">{top_users[2] ? top_users[2].growth : 0}</p>*/}
											{/*	/!*<img alt={"alt"} src={arrow_down} className="arrow_down_green"/>*!/*/}
											{/*</div>*/}
											<div className={"topper-avatar-wrap-right"}>
												{
													top_users[2] && top_users[2].avatar_url ?
														<img src={top_users[2].avatar_url} alt={"alt"}
															 className={"topper-avatar-pic"}/>
														:
														<p className={"topper-avatar-side mb-0"}>{top_users[2] && (top_users[2].short_username).toUpperCase()}</p>
												}

											</div>
											{/*<img alt={"alt"} src={ProfilePic} className="utkarsh_image "/>*/}
											<img alt={"alt"} src={three} className="number_image"/>
										</div>
										<p className="text_wrap my-1 pt-4">
											{top_users[2] ? truncate(top_users[2].user_first) : ""}

										</p>
									</Zoom>
								</div>

							</div>

							<div style={{position: 'relative', height: "175px"}}>
								<div className={'leaderboard-steps'}>
									<Fade bottom delay={100}><img src={steps} alt={"alt"}/></Fade>
								</div>

								{/* your card */}
								{
									Object.keys(current_user).length !== 0 &&
									<Flip top delay={1600} duration={1000}>
										<div className={"leaderboard-your-card p-3 d-flex justify-content-between mt-3"}
											 onClick={() => this.selectProfile(current_user)}>
											<div className={"your-card-image-wrap d-flex justify-content-between"}>
												<div style={{position: "relative", marginRight: "12px"}}>
													<Zoom delay={500}>
														<div className={"your-card-image"}>
															{
																current_user.avatar_url ?
																	<img alt={"avatar"} src={current_user.avatar_url}
																		 className={"your-avatar-image"}/>
																	:
																	<p className={"your-avatar-name mb-0"}>{current_user.short_username && (current_user.short_username).toUpperCase()}</p>

															}

														</div>
													</Zoom>
													<Zoom delay={800}><img src={profileConfetti} alt={"alt"}
																		   className={"confetti"}/></Zoom>
												</div>

												<div>
													<p className={"your-name my-1"}>
														{current_user.user_first && current_user.user_first} (me)

													</p>
													<p className={"your-growth my-1"}>Growth: <span
														style={{fontWeight: 500, fontSize: "14px"}}>
											{current_user.user_first && isNanHandler(current_user.growth) + "%"}

										</span></p>
												</div>
											</div>
											<div className={"d-flex align-items-center text-right"}>

												{
													this.state.confettiFired && <div style={{position: "relative"}}>
														<div className={"animation-cup-bg"}>
															{
																!this.state.yourCardConfetti ?
																	<Zoom bottom delay={1000} duration={2000}>
																		<img src={animationCup_bg} alt={"alt"}
																			 className={""}/>
																	</Zoom>
																	:
																	<div
																		className={"ZoomOutButton animate__animated animate__fadeOutDown "}>
																		<img src={animationCup_bg} alt={"alt"}
																			 className={""}/>
																	</div>
															}

														</div>

														<div className={"animation-cup"}>
															<Zoom delay={500}><img src={animationCup} alt={"alt"}
																				   className={"your-card-cup"}/></Zoom>
														</div>
													</div>
												}

												<div className={"mx-2"}>
													<div className={"your-price my-1"}>
														{
															this.state.loading ? "NILL" :
																<FlipAnimation value={current_user.place}
																			   color={"#ffffff"}
																			   pixel={14}/>

														}
													</div>
													<img src={current_user.growth > 0 ? growthArrow : lossArrow}
														 alt={"alt"}
														 className={"growth-img"}/>
												</div>
											</div>
										</div>
									</Flip>

								}

							</div>

						</div>
						{/* leaderboard list    */}

						<Fade bottom delay={1000}>
							<div className={'mt-4 mb-2 leaderboard-list-wrapper p-2'}
								// style={{display:Object.keys(current_user).length === 0 && leader_board_data.length === 0 ?'none':'block'}}
							>

								{
									Object.keys(current_user).length === 0 &&
									<div className={"newuser-white_wrapper"}>
										<div className={"newuser-card pl-3"}>
											<div className={"d-flex align-items-end"}>
												<div>
													<p className={"heading mb-1"}>Can’t Find Yourself?</p>
													<p className={"para mb-4"}>We are calculating your rank. Please check back in a few minutes.</p>
												</div>
												<img src={newuserIllustration} alt={"alt"} className={"newuser-illustration"}/>
											</div>

										</div>
									</div>
								}

								{
									leader_board_data.map((item, index) => {

										// if (this.state.count <= 4) {
										//
										// 	this.setState({count: this.state.count + 1})
										// 	console.log(this.state.count)
										// } else {
										// 	this.setState({count: 0})
										// 	console.log(this.state.count)
										// }
										return <div key={item.id}>
											<Fade bottom cascade>
												<div
													onClick={() => this.selectProfile(item)}
													className={"leaderboard-list my-1 py-2 px-1"}>
													<div className={"container-fluid"}>
														<div className={'d-flex justify-content-between'}>
															<div
																className={'d-flex justify-content-between align-items-center'}>
																{/*<img alt={"alt"} src={ProfilePic}*/}
																{/*     className="image_person px-2 "/>*/}
																<div className={"image_person px-2"}>
																	{
																		item.avatar_url ?
																			<img src={item.avatar_url} alt={"alt"}
																				 className={"image_avatar_pic"}/>
																			:
																			<p className={"image_avatar_text mb-0"}
																			   style={{color: this.state.colorList[index]}}>{(item.short_username).toUpperCase()}</p>
																	}

																</div>
																<div>
																	<p className="image_text_growth  ">
																		{item.user_first}
																	</p>
																	<p className="image_percentage_growth  mb-0">
																		Growth: <span
																		className="number_growth_percentage">
															{
																isNanHandler(item.growth) + "%"
															}
														</span>
																	</p>
																</div>
															</div>
															<div className={'text-center'}>
																<p className="image_growth my-1">
																	{
																		item.place
																	}
																</p>
																<img alt={"alt"}
																	 src={item.growth > 0 ? growthArrow : lossArrow}
																	 className="arrow_up_green_part  mb-1 "/>
															</div>
														</div>
													</div>
												</div>
											</Fade></div>
									})
								}

							</div>
						</Fade>
						<br/>
						<br/>
						<br/>

						<div className="container">
							{/*<div style={{height: "150px"}}/>*/}
							<MDBBox className="bottom-navbar">
								<BottomNav active_page={"chart"}/>
							</MDBBox>
						</div>
						<MDBModal fullHeight={false} position="bottom"
								  overflowScroll={true}
								  inline={false} id={"profile-modal"}
								  noClickableBodyWithoutBackdrop={false}
								  isOpen={this.state.currentModal !== ""}>
							<MDBModalBody>
								{
									this.state.currentModal === "add" ?
										<AddMoney
											setActiveModal={(args) => this.setActiveModal(args)}
											user_details={this.props.user_details}
										/> :
										this.state.currentModal === "withdraw" ?
											<WithdrawMoney
												setActiveModal={(args) => this.setActiveModal(args)}
												user_details={this.props.user_details}
											/> :
											this.state.currentModal === "cash" ?
												<CashDetail setActiveModal={(args) => {
													this.setActiveModal(args)
												}}/> :
												null
								}

							</MDBModalBody>
						</MDBModal>

					</MDBBox>
					<Login isOpen={this.state.login_modal}
						   closeModal={this.closeLoginModal}
						   completeLogin={this.completeLogin}
					/>
				</>
			</Loading>
		);
	}
}

const mapStateToProps = state => ({
	user_details: state.UserReducer.user_details,
	logged_in: state.UserReducer.logged_in

})

const mapDispatchToProps = dispatch => ({
	setUserProfileData: data => dispatch(AddProfileData(data)),
	setActivePage: data => dispatch(setActivePage(data)),

})

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps)
)(Profile)
